import { type TaskTroubleshootInput, type TaskTroubleshootSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { type GetHookResponse } from '../hooks'

export function useTaskTroubleshoot(input: TaskTroubleshootInput): GetHookResponse<TaskTroubleshootSuccess> {
  return useTantalimQuery<TaskTroubleshootInput, TaskTroubleshootSuccess, TaskTroubleshootSuccess>({
    url: '/task/troubleshoot',
    queryKey: ['task-troubleshoot', input.ownerId, input.taskId],
    input,
    convertResponse: (data) => data,
  })
}
